import { _id } from 'src/_mock/assets';

// ----------------------------------------------------------------------

const MOCK_ID = _id[1];

const ROOTS = {
  AUTH: '/auth',
  AUTH_DEMO: '/auth-demo',
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  paymentSuccess: '/payment-success',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
  docs: 'https://docs.voolist.com',
  changelog: '/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/hjxMnGUJCjY7pX8lQbS7kn/%5BPreview%5D-Minimal-Web.v5.4.0?type=design&node-id=0-1&mode=design&t=2fxnS70DuiTLGzND-0',
  product: {
    root: `/product`,
    checkout: `/product/checkout`,
    details: (id) => `/product/${id}`,
    demo: {
      details: `/product/${MOCK_ID}`,
    },
  },
  // AUTH
  auth: {

    login: `${ROOTS.AUTH}/login`,
    register: `${ROOTS.AUTH}/register`,
    forgotPassword: `${ROOTS.AUTH}/forgot-password`,
    newPassword: `${ROOTS.AUTH}/new-password`,
    verify: `${ROOTS.AUTH}/verify`,


  },

  // DASHBOARD
  dashboard: {
    root: `/`,
    general: {
      app: `${ROOTS.DASHBOARD}/app`,
      ecommerce: `${ROOTS.DASHBOARD}/ecommerce`,
    },

    listing: {
      root: `/listing`,
      new: `/listing/new`,
      details: (id) => `/listing/${id}`,
      edit: (id) => `/listing/${id}/edit`,
      archived: '/listing/archived',
      bulkCrossList: '/listing/bulk-cross-list',
      bulkCrossListBatch: (batchId) => `/listing/bulk-cross-list/batch/${batchId}`,
      merge: '/listing/merge',
      mergeBatch: (batchId) => `/listing/merge/batch/${batchId}`,
      demo: {
        details: `/listing/${MOCK_ID}`,
        edit: `/listing/${MOCK_ID}/edit`,
      },
    },
    order: {
      root: `${ROOTS.DASHBOARD}/order`,
      details: (id) => `${ROOTS.DASHBOARD}/order/${id}`,
      demo: {
        details: `${ROOTS.DASHBOARD}/order/${MOCK_ID}`,
      },
    },

  },
  // Guided setup for a new seller: connect, import, and first cross-list.
  setup: `/setup`,
  management: {
    stores: `/stores`,
    preferences: `/store-preferences`,
    shippingProfiles: `/shipping-profiles`,
  },
  account: {
    root: `/account`,
    general: `/account/general`,
    billing: `/account/billing`,
    notifications: `/account/notifications`,
    social: `/account/social`,
    security: `/account/security`,
  },
  knowledgeBase: {
    root: `/knowledge-base`,
    article: (id) => `/knowledge-base/${id}`,
  },
  studio: {
    templates: '/studio/templates',
    newTemplate: '/studio/templates/new',
    editTemplate: (id) => `/studio/templates/${id}/edit`,
  },
  admin: {
    root: `/admin`,
    dashboard: `/admin/dashboard`,
  },
};
